// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   MdSearch,
//   MdClear,
//   MdDownload,
//   MdChevronLeft,
//   MdChevronRight,
//   MdFirstPage,
//   MdLastPage,
// } from "react-icons/md";
// import BulkImportButton from "components/common/BulkImportButton";

// import { getExhibitor, deleteExhibitor } from "api/exhibitor.api";
// import ExhibitorTable from "components/exhibitor/ExhibitorTable";
// import Alert from "components/common/Alert";
// import PageLayout from "components/PageFromLayout";

// export default function Exhibitors() {
//   const navigate = useNavigate();

//   const [data, setData] = useState([]);
//   const [alert, setAlert] = useState("");

//   const [search, setSearch] = useState("");
//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   const [selectedOrganizer, setSelectedOrganizer] = useState(
//     localStorage.getItem("company_id") || ""
//   );

//   const userId = "69579c6190a653b640e65639";

//   const fetchData = async () => {
//     try {
//       const res = await getExhibitor(selectedOrganizer);
//       setData(res.data || []);
//     } catch (error) {
//       console.error("Failed to fetch exhibitors:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [selectedOrganizer]);

//   useEffect(() => {
//     const handleOrganizerChange = (e) => {
//       setSelectedOrganizer(e.detail);
//     };
//     window.addEventListener("companyChanged", handleOrganizerChange);
//     return () =>
//       window.removeEventListener("companyChanged", handleOrganizerChange);
//   }, []);

//   const filteredData = data.filter((item) =>
//     [
//       item.title,
//       item.email,
//       item.manager_email,
//       item.phone_number,
//       item.country,
//       item.status,
//       item.exhibitor_category?.name,
//     ]
//       .join(" ")
//       .toLowerCase()
//       .includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredData.length / limit);

//   const paginatedData = filteredData.slice((page - 1) * limit, page * limit);

//   const handleDelete = async (id) => {
//     await deleteExhibitor(id, {
//       is_deleted: true,
//       deleted_by: userId,
//     });

//     setAlert("Exhibitor deleted successfully");
//     fetchData();
//   };

//   const exportCSV = () => {
//     const headers = ["Title", "Exhibitor Category", "Country", "Status"];

//     const rows = filteredData.map((e) => [
//       e.title,
//       e.exhibitor_category?.name,
//       e.country,
//       e.status,
//     ]);

//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       [headers, ...rows].map((r) => r.join(",")).join("\n");

//     const link = document.createElement("a");
//     link.href = encodeURI(csvContent);
//     link.download = "exhibitors.csv";
//     link.click();
//   };

//   return (
//     <PageLayout title={"Exhibitors"} subtitle={"Manage all exhibitors on the platform. Review, edit, search, and update their profiles."}>
//       <div className="p-4">
//         <div className="mb-4 flex items-center justify-between">
//           <div className="flex items-center gap-2">
//             <div className="relative">
//               <MdSearch className="absolute left-3 top-2.5 text-lg text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search..."
//                 value={search}
//                 onChange={(e) => {
//                   setSearch(e.target.value);
//                   setPage(1);
//                 }}
//                 className="w-64 rounded-md border py-2 pl-10 pr-8 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
//               />

//               {search && (
//                 <button
//                   onClick={() => setSearch("")}
//                   className="absolute right-2 top-2.5 text-gray-400 hover:text-gray-600"
//                 >
//                   <MdClear />
//                 </button>
//               )}
//             </div>

//             <button
//               onClick={exportCSV}
//               className="flex items-center gap-1 rounded-lg bg-green-500 px-2 py-1 text-white"
//             >
//               <MdDownload />
//               CSV
//             </button>
//           </div>
//           <div className="flex items-center gap-2">
//             <BulkImportButton
//               module="exhibitors"
//               label="Import Exhibitors"
//               onSuccess={fetchData}
//               companyId={selectedOrganizer}
//             />
//             <Link
//               to="/admin/exhibitors/create"
//               className="rounded-md bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
//             >
//               Add Exhibitor
//             </Link>
//           </div>
//         </div>

//         {alert && (
//           <Alert type="success" message={alert} onClose={() => setAlert("")} />
//         )}

//         <div className="rounded-md border bg-white shadow-sm">
//           <ExhibitorTable
//             data={paginatedData}
//             onEdit={(row) => navigate(`/admin/exhibitors/edit/${row._id}`)}
//             onDelete={handleDelete}
//           />

//           <div className="flex items-center justify-between border-t px-4 py-3 text-sm">
//             <span className="text-gray-500">{filteredData.length} total</span>

//             <div className="flex items-center gap-1">
//               <select
//                 value={limit}
//                 onChange={(e) => {
//                   setLimit(Number(e.target.value));
//                   setPage(1);
//                 }}
//                 className="rounded-md border px-2 py-2 text-sm"
//               >
//                 <option value={10}>10 / page</option>
//                 <option value={25}>25 / page</option>
//                 <option value={50}>50 / page</option>
//               </select>

//               <button
//                 disabled={page === 1}
//                 onClick={() => setPage(1)}
//                 className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//               >
//                 <MdFirstPage />
//               </button>

//               <button
//                 disabled={page === 1}
//                 onClick={() => setPage(page - 1)}
//                 className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//               >
//                 <MdChevronLeft />
//               </button>

//               <span className="px-3 font-medium">
//                 {page} / {totalPages || 1}
//               </span>

//               <button
//                 disabled={page === totalPages}
//                 onClick={() => setPage(page + 1)}
//                 className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//               >
//                 <MdChevronRight />
//               </button>

//               <button
//                 disabled={page === totalPages}
//                 onClick={() => setPage(totalPages)}
//                 className="rounded border p-2 hover:bg-gray-100 disabled:opacity-40"
//               >
//                 <MdLastPage />
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </PageLayout>
//   );
// }

import { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MdSearch, MdDownload, MdAddBox } from "react-icons/md";
import TablePageLayout from "components/TablePageLayout";
import Pagination from "components/Pagination";
import BulkImportButton from "components/common/BulkImportButton";
import SampleDownloadButton from "components/common/SampleDownloadButton";
import { getExhibitor, deleteExhibitor } from "api/exhibitor.api";
import ExhibitorTable from "components/exhibitor/ExhibitorTable";
import { InputField } from "components/FormFields";
import CustomButton from "components/CustomButton";
import Alert from "components/common/Alert";
import SideDrawerModal from "components/SideDrawerModal";
import ViewExhibitorDetails from "components/exhibitor/ViewExhibitorDetails";

export default function Exhibitors() {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [alert, setAlert] = useState("");
  const [userId, setUserId] = useState("69579c6190a653b640e65639");
  const [role, setRole] = useState("admin");

  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedExhibitor, setSelectedExhibitor] = useState(null);

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );
  const [paginationInfo, setPaginationInfo] = useState({
    totalExhibitors: 0,
    totalPages: 1,
  });
  const abortControllerRef = useRef(null);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    if (userData._id) {
      setUserId(userData._id);
    }
    if (userData.role) {
      setRole(userData.role);
    }
  }, []);

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);

  // Fetch exhibitors
  const fetchData = useCallback(async () => {
    if (!selectedOrganizer) return;

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      setLoading(true);
      const res = await getExhibitor(selectedOrganizer, {
        page,
        limit,
        search: debouncedSearch,
        signal: controller.signal,
      });

      const payload = res?.data || {};
      const list =
        payload.exhibitors || (Array.isArray(payload) ? payload : []);

      setData(list);
      setPaginationInfo({
        totalExhibitors: payload.pagination?.totalExhibitors || list.length,
        totalPages: payload.pagination?.totalPages || 1,
      });
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") return;
      console.error("Failed to fetch exhibitors:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedOrganizer, page, limit, debouncedSearch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };
    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  // Filter Exhibitors Client-Side
  const filteredData = data.filter((item) => {
    return [
      item.title,
      item.email,
      item.manager_email,
      item.phone_number,
      item.country,
      item.status,
      item.exhibitor_category?.name,
    ]
      .join(" ")
      .toLowerCase()
      .includes(debouncedSearch.toLowerCase());
  });

  const viewButton = (exhibitorData) => {
    setSelectedExhibitor(exhibitorData);
    setIsViewOpen(true);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((item, idx) => item._id || idx));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleDelete = async (id) => {
    await deleteExhibitor(id, {
      is_deleted: true,
      deleted_by: userId,
    });
    setAlert("Exhibitor deleted successfully");
    fetchData();
  };

  const handleExportCSV = () => {
    const exportData =
      selectedRows.length > 0
        ? filteredData.filter((item, idx) =>
            selectedRows.includes(item._id || idx)
          )
        : filteredData;

    if (!exportData.length) return;

    const headers = [
      "Title",
      "Exhibitor Category",
      "Phone",
      "Email",
      "Country",
      "Status",
    ];
    const safeStr = (val) => String(val || "").replace(/"/g, '""');

    const rows = exportData.map((e) => [
      `"${safeStr(e.title)}"`,
      `"${safeStr(e.exhibitor_category?.name)}"`,
      `"${safeStr(e.phone_number)}"`,
      `"${safeStr(e.email)}"`,
      `"${safeStr(e.country)}"`,
      `"${safeStr(e.status)}"`,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `exhibitors_${
        selectedRows.length > 0 ? "selected" : "all"
      }_${Date.now()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <TablePageLayout>
      {role !== "exhibitor" && (
        <div className="grid w-full grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col">
            <InputField
              label="SEARCH"
              name="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search exhibitor..."
              icon={<MdSearch className="text-lg text-gray-400" />}
            />
          </div>

          {/* <div className="hidden lg:block"></div> */}

          <div className="flex flex-col items-start justify-start gap-2 sm:col-span-3 sm:flex-row sm:justify-end lg:col-span-3">
            <CustomButton
              label={
                selectedRows.length > 0
                  ? `Export Selected (${selectedRows.length})`
                  : "Export CSV"
              }
              icon={MdDownload}
              iconPos="left"
              variant="outline"
              color="#1A1A1A"
              borderColor="#02a9e0"
              disabled={filteredData.length === 0}
              onClick={handleExportCSV}
            />

            <SampleDownloadButton module="exhibitors" />

            <BulkImportButton
              module="exhibitors"
              label="Import Exhibitors"
              onSuccess={fetchData}
              companyId={selectedOrganizer}
            />

            <CustomButton
              label="Add Exhibitor"
              icon={MdAddBox}
              iconPos="right"
              variant="solid"
              color="#02a9e0"
              onClick={() => navigate("/admin/exhibitors/create")}
            />
          </div>
        </div>
      )}

      {alert && (
        <Alert type="success" message={alert} onClose={() => setAlert("")} />
      )}

      {loading ? (
        <div className="rounded-xl border bg-white p-12 text-center text-sm text-gray-500 shadow-sm">
          Loading exhibitors...
        </div>
      ) : (
        <div className="table-card overflow-hidden">
          <ExhibitorTable
            data={data}
            startIndex={(page - 1) * limit}
            onRefresh={fetchData}
            onDelete={handleDelete}
            selectedRows={selectedRows}
            onSelectRow={handleSelectRow}
            onSelectAll={handleSelectAll}
            viewButton={viewButton}
            role={role}
          />

          <Pagination
            currentPage={page}
            totalPages={paginationInfo.totalPages}
            totalEntries={paginationInfo.totalExhibitors}
            limit={limit}
            onPageChange={(newPage) => setPage(newPage)}
            onLimitChange={(newLimit) => setLimit(newLimit)}
          />
        </div>
      )}

      <SideDrawerModal
        isOpen={isViewOpen}
        onClose={() => setIsViewOpen(false)}
        title={selectedExhibitor?.title || "Exhibitor Details"}
        width="600px"
      >
        <ViewExhibitorDetails data={selectedExhibitor} />
      </SideDrawerModal>
    </TablePageLayout>
  );
}
